import { useMemo } from "react";

// tests for window property added via https://scripts.mediavine.com/tags/edhrec.js
const useCanRunAds = () => useMemo(() => !!window.$adManagementConfig);

export default useCanRunAds;
